import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React, { useState, useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import GlyphClose from '../../svg/GlyphClose.js';
import Button from '../Buttons/Button.js';
import IconWarning from '../../svg/IconWarning.js';
import IconSuccess from '../../svg/IconSuccess.js';
import IconNeutral from '../../svg/IconNeutral.js';
import alert from '../../styles/alert.js';
import noop from '../../utils/noop.js';
import { padResponsive } from '../../styles/padResponsive/padResponsive.js';
import { pad1R } from '../../styles/padStatic/pad1R.js';
import { widthFull } from '../../styles/layout/widthFull.js';
import { dlsGray05 } from '../../styles/colorsDls/dlsGray05.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PageLevelMessage = function PageLevelMessage(_ref) {
  var className = _ref.className,
      type = _ref.type,
      children = _ref.children,
      dismissible = _ref.dismissible,
      defaultShow = _ref.defaultShow,
      onDismiss = _ref.onDismiss,
      filled = _ref.filled,
      icon = _ref.icon,
      theme = _ref.theme,
      otherProps = _objectWithoutProperties(_ref, ["className", "type", "children", "dismissible", "defaultShow", "onDismiss", "filled", "icon", "theme"]);

  var _useState = useState(defaultShow),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleCloseClick = function handleCloseClick(event) {
    setShow(false);
    onDismiss(event);
  };

  var styleName = useMemo(function () {
    return {
      success: {
        icon: jsx(IconSuccess, null),
        container: _objectSpread({}, alert.alertPositive)
      },
      warning: {
        icon: jsx(IconWarning, null),
        container: _objectSpread({}, alert.alertWarn)
      },
      neutral: {
        icon: jsx(IconNeutral, null),
        container: _objectSpread({}, alert.alertNeutral)
      }
    };
  }, []);
  var customIconTheme = icon && icon.props && icon.props.theme ? icon.props.theme : {};
  var iconToRender = /*#__PURE__*/React.cloneElement(icon || styleName[type].icon, {
    size: icon ? icon.props.size : 'md',
    filled: filled,
    theme: _objectSpread(_objectSpread({
      fill: styleName[type].container.color
    }, pad1R), customIconTheme)
  });
  var containerCss = useMemo(function () {
    return merge.all([alert.alert, alert.alertDismissible, padResponsive, styleName[type].container, theme]);
  }, [theme, styleName, type]);
  return show && jsx("div", _extends({
    css: containerCss,
    role: "alert"
  }, otherProps, {
    className: className
  }), iconToRender, jsx("span", {
    css: widthFull
  }, children), dismissible && jsx(Button, {
    onClick: handleCloseClick,
    theme: {
      minWidth: '1rem'
    }
  }, jsx(GlyphClose, {
    title: "close",
    size: "lg",
    theme: dlsGray05
  })));
};

PageLevelMessage.defaultProps = {
  className: '',
  dismissible: true,
  defaultShow: true,
  onDismiss: noop,
  filled: false,
  icon: undefined,
  theme: {}
};

export default PageLevelMessage;
